import { type AppKey, useAvailableApps } from '@scoring/logic';
import { DefaultLoader } from '@scoring/ui';
import { Navigate, Outlet } from 'react-router';

export const RequireApp = ({ app }: { app: AppKey }) => {
    const { apps, isLoading } = useAvailableApps();
    if (isLoading) return <DefaultLoader />;
    return apps.includes(app) ? <Outlet /> : <Navigate to="/" replace />;
};
